import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import config from 'constants/config'
import { TOUR_STYLED_PRODUCT_TYPE_TITLES } from 'constants/tours'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import React, { ComponentProps, useCallback } from 'react'

export type TourStyledSignatureSeriesProductTypeInfoModalResult = 'primary-action' | undefined

type InheritedModalProps = Pick<ComponentProps<typeof Modal>, 'primaryActionText' | 'primaryActionTo'>

type Props = InheritedModalProps

function TourStyledSignatureSeriesProductTypeInfoModal({
  primaryActionText,
  primaryActionTo,
}: Props) {
  const modalElement = useModalElementContext<TourStyledSignatureSeriesProductTypeInfoModalResult>()

  const handlePrimaryClick = useCallback(() => {
    modalElement.resolve('primary-action')
  }, [modalElement])

  return <Modal
    size="L"
    title={<>{config.brandConfig.name} Tour Styles</>}
    subtitle={TOUR_STYLED_PRODUCT_TYPE_TITLES.insider_series_tour}
    primaryActionText={primaryActionText}
    primaryActionTo={primaryActionTo}
    onPrimaryActionClick={!primaryActionTo ? handlePrimaryClick : undefined}
  >
    <VerticalSpacer gap={24}>
      <BodyText variant="medium" colour="neutral-two">
        These expertly curated journeys are co-designed by some of Australia's most trusted personalities and tastemakers. With itineraries built on authentic recommendations, Luxury Escapes' Insider Series takes you beyond the ordinary on an adventure designed by an expert.
      </BodyText>
      <Group
        direction="vertical"
        tabletDirection="horizontal"
        tabletHorizontalAlign="stretch"
        gap={24}
      >
        <VerticalSpacer gap={4}>
          <BodyText variant="medium" weight="bold" colour="neutral-one">
            The Insider's Itinerary
          </BodyText>
          <BodyText variant="medium" colour="neutral-two">
            A unique journey with experiences personally curated by our expert host, showcasing their favourite spots, recommendations, and must-do experiences in the destination.
          </BodyText>
        </VerticalSpacer>
        <VerticalSpacer gap={4}>
          <BodyText variant="medium" weight="bold" colour="neutral-one">
            Expertly Curated, Seamlessly Delivered
          </BodyText>
          <BodyText variant="medium" colour="neutral-two">
            Get the best of both worlds—a tour built on the personal knowledge and authentic recommendations of a trusted insider, all seamlessly delivered with the world-class service and quality you expect from a Luxury Escapes holiday.
          </BodyText>
        </VerticalSpacer>
        <VerticalSpacer gap={4}>
          <BodyText variant="medium" weight="bold" colour="neutral-one">
            Small Group Journeys
          </BodyText>
          <BodyText variant="medium" colour="neutral-two">
            Journey with a small, like-minded group, allowing for more intimate experiences and greater personal access to each handpicked destination.
          </BodyText>
        </VerticalSpacer>
      </Group>
    </VerticalSpacer>
  </Modal>
}

export default TourStyledSignatureSeriesProductTypeInfoModal
